/* Infinite horizontal loop for product carousels (clones the slides before/after the originals). */
(function () {
  'use strict';
  function setup(scroller) {
    if (scroller.dataset.klLoop) return;
    var originals = Array.prototype.filter.call(scroller.children, function (el) {
      return el.classList.contains('resource-list__slide');
    });
    if (originals.length < 3) return;
    var slideshow = scroller.closest('slideshow-component');
    function pos(el) {
      return el.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
    }
    var first = originals[0];
    var last = originals[originals.length - 1];
    var span = pos(last) + last.offsetWidth - pos(first);
    if (span < scroller.clientWidth * 1.3) return;
    scroller.dataset.klLoop = '1';

    function clone(el) {
      var c = el.cloneNode(true);
      c.setAttribute('data-kl-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('ref');
      c.removeAttribute('slide-id');
      c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      return c;
    }
    var before = originals.map(clone);
    var after = originals.map(clone);
    before.forEach(function (c) { scroller.insertBefore(c, first); });
    var ref = last.nextSibling;
    after.forEach(function (c) { scroller.insertBefore(c, ref); });

    var setW = pos(after[0]) - pos(first);
    var snap = scroller.style.scrollSnapType;
    function jump(x) {
      var sb = scroller.style.scrollBehavior;
      scroller.style.scrollBehavior = 'auto';
      scroller.style.scrollSnapType = 'none';
      scroller.scrollTo({ left: x, behavior: 'instant' });
      requestAnimationFrame(function () {
        scroller.style.scrollSnapType = snap;
        scroller.style.scrollBehavior = sb;
      });
    }
    jump(scroller.scrollLeft + setW);

    var timer;
    function normalize() {
      if (slideshow && slideshow.hasAttribute('dragging')) { timer = setTimeout(normalize, 120); return; }
      var x = scroller.scrollLeft;
      if (x < setW * 0.5) jump(x + setW);
      else if (x >= setW * 1.5) jump(x - setW);
    }
    scroller.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(normalize, 140);
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.resource-list__carousel > slideshow-container > slideshow-slides').forEach(setup);
  }
  function start() { setTimeout(init, 400); setTimeout(init, 1500); }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
